import { Box, Grid, Paper, Typography } from "@mui/material";
import { OperationPrintTransfersDetailsProps } from "types";
import OperationPrintDetails from "./OperationPrintDetails";

export default function OperationPrintTransfersDetails({
  movements,
  users = [],
}: OperationPrintTransfersDetailsProps) {
  const firstMovement = movements[0];

  const preparedByUser = users.find((u) => u.id === firstMovement.updated_by);

  return (
    <>
      <style>
        {`
          @media print {
            @page {
              size: A4 portrait;
              margin: 0;
            }
          }
        `}
      </style>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Grid
              container
              padding={2}
              component={Paper}
              sx={{
                border: "1px solid grey",
                borderRadius: "0.5rem",
              }}
            >
              <Grid item xs={4} display="flex" flexDirection="column" gap={1}>
                <Typography variant="body2">
                  <b>Cliente:</b> {firstMovement.client?.razon_social}
                </Typography>

                <Typography variant="body2">
                  <b>Nro. de Planilla:</b> {firstMovement.client_document}
                </Typography>
              </Grid>

              <Grid item xs={4} display="flex" flexDirection="column" gap={1}>
                <Typography variant="body2">
                  <b>Preparó:</b>{" "}
                  {preparedByUser
                    ? `${preparedByUser.first_name} ${preparedByUser.last_name}`
                    : "Sin usuario asignado"}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {movements.map((movement, index) => (
            <Grid
              item
              xs={12}
              key={movement.id}
              sx={{
                "@media print": {
                  breakBefore: index === 0 ? "auto" : "page",
                  pageBreakBefore: index === 0 ? "auto" : "always",
                },
              }}
            >
              <Box
                sx={{
                  width: "100%",
                  "@media print": {
                    minHeight: index === 0 ? "auto" : "210mm",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    breakInside: "avoid",
                    pageBreakInside: "avoid",
                  },
                }}
              >
                <OperationPrintDetails
                  movement={movement}
                  client={firstMovement.client || movement.client || null}
                  users={users}
                  hideMovementHeaderDetails
                  title={`Transferencia ${movement.id ?? "-"}`}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
    </>
  );
}